import { useEffect, useState } from "react";
import { useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { DataGridTopHeader } from "../../../../components/styled";
import { getAllTeachers } from "../../../../api/teacher";
import { techerTableColumns } from "../../../../data/mockTableColumns";
import DashboardLayout from "../../../../components/global/DashboardLayout";
import DashboardHeader from "../../../../components/global/DashboardHeader";

const Teachers = () => {
  const [teachers, setTeachers] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const theme = useTheme();

  useEffect(() => {
    const fetchAllTeachers = async () => {
      try {
        const allTeachers = await getAllTeachers();
        setTeachers(allTeachers);
      } catch (error) {
        console.error("Error:", error);
      }
    };

    fetchAllTeachers();
  }, []);

  // Filtered teachers based on search query
  const filteredTeachers = teachers.filter(
    (teacher) =>
      teacher.firstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      teacher.lastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      teacher.email.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <DashboardLayout>
      {/* HEADER */}
      <DashboardHeader
        title="Teachers"
        subtitle="List of All Teachers Profile"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <DataGridTopHeader theme={theme}>
        <DataGrid
          rows={filteredTeachers}
          columns={techerTableColumns}
          getRowId={(row) => row._id}
          checkboxSelection
          disableRowSelectionOnClick
          pageSizeOptions={[10, 20, 30]}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          slots={{
            toolbar: GridToolbar,
          }}
        />
      </DataGridTopHeader>
    </DashboardLayout>
  );
};

export default Teachers;
